export interface LatLng {
    lat: number,
    lng: number
}

// export const CHICAGO: LatLng = {lat: 41.939292, lng: -87.650396}
export const HAWAII: LatLng = {lat: 21.3069, lng: -157.8583}
export const DEFAULT_ZOOM = 16
export const INITIAL_ZOOM = 15
